var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9271 19.3904C30.7309 19.1187 26.0316 12.7344 20 12.7344C13.9692 12.7344 9.26979 19.1194 9.07292 19.3904C8.80903 19.7538 8.80903 20.2456 9.07292 20.6076C9.26979 20.8814 13.9692 27.265 20 27.265C26.0316 27.265 30.7309 20.8807 30.9271 20.6076C31.191 20.2456 31.191 19.7531 30.9271 19.3904ZM18.2677 18.6446C17.8931 19.1738 17.8056 19.8632 18.0081 20.6958C18.1435 21.2525 17.8027 21.8121 17.246 21.9468C17.1642 21.9673 17.0809 21.9743 17.0005 21.9743C16.5333 21.9743 16.1093 21.6561 15.9943 21.1834C15.5321 19.2817 16.1234 18.0314 16.6999 17.299C17.488 16.2977 18.7137 15.7784 19.468 15.7784C19.4694 15.7784 19.4701 15.7784 19.4701 15.7784C20.0423 15.7784 20.5066 16.2229 20.5052 16.7952C20.5038 17.3618 20.048 17.8105 19.4842 17.8204C19.3 17.8402 18.6721 18.0737 18.2677 18.6446ZM22.1557 23.5408C21.4366 23.5408 20.8545 22.9594 20.8545 22.2404C20.8545 21.5206 21.4366 20.9378 22.1557 20.9378C22.8747 20.9378 23.4575 21.5206 23.4575 22.2404C23.4568 22.9587 22.874 23.5408 22.1557 23.5408ZM11.2377 19.9993C12.1635 18.8993 14.322 16.5969 16.9934 15.4637C15.4481 16.4297 14.42 18.1457 14.42 20.1031C14.42 21.726 15.1278 23.1838 16.2518 24.1843C13.9254 22.9798 12.076 20.995 11.2377 19.9993ZM23.1978 24.4546C24.5089 23.4554 25.3577 21.8791 25.3577 20.1031C25.3577 17.9538 24.118 16.0952 22.3151 15.2019C25.302 16.1961 27.7617 18.8083 28.7658 20.0008C27.8619 21.0754 25.7853 23.2974 23.1978 24.4546Z",
    fill: "url(#paint0_radial_5230_24407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24407",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8078 31.508) rotate(-90) scale(22.3608 102.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK30);
export default __webpack_public_path__ + "static/media/K30.15d4f5a15c20158aa432f983dafa7a3b.svg";
export { ForwardRef as ReactComponent };